import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=b4e42da6&scoped=true&lang=pug&"
import script from "./Radio.vue?vue&type=script&lang=js&"
export * from "./Radio.vue?vue&type=script&lang=js&"
import style0 from "./Radio.vue?vue&type=style&index=0&id=b4e42da6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e42da6",
  null
  
)

export default component.exports